import axios from 'axios';
import {
  ABOUT_TEXT_API_URL,
  ABOUT_MAIN_TOP_TEXT_API_URL,
  ABOUT_MAIN_BOTTOM_TEXT_API_URL,
  AFTER_SUBMIT_TEXT_API_URL,
  BEFORE_AUTH_TEXT_API_URL,
  DOCUMENTS_TEXT_API_URL,
  MEMBERS_TEXT_API_URL,
  ACTION_BUTTON_TEXT_API_URL,
  SHORT_LIST_MESSAGE_API_URL,
  PARTNERS_TEXT_API_URL,
  LIVE_HEADER_API_URL,
  LIVE_TOP_TEXT_API_URL,
  LIVE_STREAM_API_URL,
  ANNOUNCEMENT_RESULT_TEXT_API_URL,
} from '../../constants/urls';

const state = {
    aboutText: null,
    aboutMainTopText: null,
    aboutMainBottomText: null,
    afterSubmitText: null,
    beforeAuthText: null,
    documentsText: null,
    membersText: null,
    actionButtonText: null,
    shortListMessage: null,
    partnersText: null,
    year: null,
    liveHeader: null,
    liveTopText: null,
    liveStream: null,
    announcementResultsText: null,
};

const actions = {
    getAboutText({ commit }) {
        const host = this.state.context.host;

        axios.get( host + ABOUT_TEXT_API_URL, { withCredentials: true } )
            .then((result) => {
                commit('aboutText', result.data.content);
            })
            .catch((error) => {
                /* eslint-disable no-console */
                console.log(error);
            });
    },

    getBeforeAuthText({ commit }) {
        const host = this.state.context.host;

        axios.get( host + BEFORE_AUTH_TEXT_API_URL, { withCredentials: true } )
            .then((result) => {
                commit('beforeAuthText', result.data.content);
            })
            .catch((error) => {
                /* eslint-disable no-console */
                console.log(error);
            });
    },

    getMembersText({ commit }) {
        const host = this.state.context.host;

        axios.get( host + MEMBERS_TEXT_API_URL, { withCredentials: true })
            .then((result) => {
                commit('membersText', result.data.content);
        })
        .catch((error) => {
            /* eslint-disable no-console */
            console.log(error);
        });
    },

    getAboutMainTopText({ commit }) {
        const host = this.state.context.host;

        axios.get( host + ABOUT_MAIN_TOP_TEXT_API_URL, { withCredentials: true } )
            .then((result) => {
                commit('aboutMainTopText', result.data.content);
            })
            .catch((error) => {
                /* eslint-disable no-console */
                console.log(error);
            });
    },

    getAboutMainBottomText({ commit }) {
        const host = this.state.context.host;

        axios.get( host + ABOUT_MAIN_BOTTOM_TEXT_API_URL, { withCredentials: true } )
            .then((result) => {
                commit('aboutMainBottomText', result.data.content);
            })
            .catch((error) => {
                /* eslint-disable no-console */
                console.log(error);
            });
    },

    getAfterSubmitText({ commit }) {
        const host = this.state.context.host;

        axios.get( host + AFTER_SUBMIT_TEXT_API_URL, { withCredentials: true } )
            .then((result) => {
                commit('afterSubmitText', result.data.content);
            })
            .catch((error) => {
                /* eslint-disable no-console */
                console.log(error);
            });
    },

    getDocumentsText({ commit }) {
        const host = this.state.context.host;

        axios.get(host + DOCUMENTS_TEXT_API_URL, { withCredentials: true } )
            .then((result) => {
                commit('documentsText', result.data.content);
            })
            .catch((error) => {
                /* eslint-disable no-console */
                console.log(error);
            });
    },

    getPartnersText({ commit }) {
      const host = this.state.context.host;

      axios.get(host + PARTNERS_TEXT_API_URL, { withCredentials: true } )
          .then((result) => {
              commit('partnersText', result.data.content);
          })
          .catch((error) => {
              /* eslint-disable no-console */
              console.log(error);
          });
  },

    getActionButtonText({ commit }) {
        const host = this.state.context.host;

        axios.get( host + ACTION_BUTTON_TEXT_API_URL, { withCredentials: true } )
            .then((result) => {
                commit('actionButtonText', result.data.content);
                commit('year', result.data.year);
            })
            .catch((error) => {
                /* eslint-disable no-console */
                console.log(error);
            });
    },

    getShortListMessage({ commit }, params) {
        const host = this.state.context.host;

        axios.get( host + SHORT_LIST_MESSAGE_API_URL, { withCredentials: true } )
            .then((result) => {
                commit('shortListMessage', result.data.content);
            })
            .catch((error) => {
                /* eslint-disable no-console */
                console.log(error);
            });
    },

    getLiveHeader({ commit }) {
      const host = this.state.context.host;

      axios.get(host + LIVE_HEADER_API_URL, { withCredentials: true } )
          .then((result) => {
              commit('liveHeader', result.data.content);
          })
          .catch((error) => {
              /* eslint-disable no-console */
              console.log(error);
          });
  },

    getLiveTopText({ commit }) {
      const host = this.state.context.host;

      axios.get(host + LIVE_TOP_TEXT_API_URL, { withCredentials: true } )
          .then((result) => {
              commit('liveTopText', result.data.content);
          })
          .catch((error) => {
              /* eslint-disable no-console */
              console.log(error);
          });
    },

    getLiveStream({ commit }) {
      const host = this.state.context.host;

      axios.get(host + LIVE_STREAM_API_URL, { withCredentials: true } )
          .then((result) => {
              commit('liveStream', result.data.content);
          })
          .catch((error) => {
              /* eslint-disable no-console */
              console.log(error);
          });
    },

    getAnnouncementResultsText({ commit }) {
      const host = this.state.context.host;

      axios.get( host + ANNOUNCEMENT_RESULT_TEXT_API_URL, { withCredentials: true })
        .then((result) => {
          commit('announcementResultsText', result.data.content.trim());
        })
        .catch((error) => {
          /* eslint-disable no-console */
          console.log(error);
        });
    },
};

const mutations = {
    aboutText(state, value) {
        state.aboutText = value;
    },

    membersText(state, value) {
        state.membersText = value;
    },

    aboutMainTopText(state, value) {
        state.aboutMainTopText = value;
    },

    aboutMainBottomText(state, value) {
        state.aboutMainBottomText = value;
    },

    afterSubmitText(state, value) {
        state.afterSubmitText = value;
    },

    beforeAuthText(state, value) {
        state.beforeAuthText = value;
    },

    documentsText(state, value) {
        state.documentsText = value;
    },

    documentsTitle(state, value) {
      state.documentsTitle = value;
    },

    partnersText(state, value) {
      state.partnersText = value;
    },

    actionButtonText(state, value) {
        state.actionButtonText = value;
    },

    shortListMessage(state, value) {
        state.shortListMessage = value;
    },

    year(state, value) {
      state.year = value;
    },

    liveHeader(state, value) {
      state.liveHeader = value;
    },

    liveTopText(state, value) {
      state.liveTopText = value;
    },

    liveStream(state, value) {
      state.liveStream = value;
    },

    announcementResultsText(state, value) {
      state.announcementResultsText = value;
    },
};

const getters = {
    aboutText({ aboutText }) {
        return aboutText;
    },

    membersText({ membersText }) {
        return membersText;
    },

    aboutMainTopText({ aboutMainTopText }) {
        return aboutMainTopText;
    },

    aboutMainBottomText({ aboutMainBottomText }) {
        return aboutMainBottomText;
    },

    afterSubmitText({ afterSubmitText }) {
        return afterSubmitText;
    },

    beforeAuthText({ beforeAuthText }) {
        return beforeAuthText;
    },

    documentsText({ documentsText }) {
        return documentsText;
    },

    documentsTitle({ documentsTitle }) {
      return documentsTitle;
    },

    partnersText({ partnersText }) {
      return partnersText;
    },

    actionButtonText({ actionButtonText }) {
        return actionButtonText;
    },

    shortListMessage({ shortListMessage }) {
        return shortListMessage;
    },

    eventsYear({ year }) {
      return year;
    },

    liveHeader({ liveHeader }) {
      return liveHeader;
    },

    liveTopText({ liveTopText }) {
      return liveTopText;
    },

    liveStream({ liveStream }) {
      return liveStream;
    },

    announcementResultsText({ announcementResultsText }) {
      return announcementResultsText;
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/texts.js